import React from 'react';
import { Form, Select } from 'antd';
import PropTypes from 'prop-types';

import CostcodesTreeSelector from '../../costcodes/CostcodesTreeSelector';

const TIME_TYPES = [
  { label: 'Regular', value: 'regular' },
  { label: 'Break', value: 'break' },
  { label: 'Overtime', value: 'overtime' },
  { label: 'Double OT', value: 'doubleOT' },
  { label: 'PTO', value: 'pto' },
];

function CustomExportTimeTrackingFilters({
  onFilterChange,
  selectedProjects,
  selectedCostcodes,
  selectedTimeTypes,
}) {
  return (
    <>
      <Form.Item
        name="costcodes"
        label="Cost Codes"
      >
        <CostcodesTreeSelector
          onChange={onFilterChange('costcodes')}
          projectIds={selectedProjects}
          includeGlobal={false}
          isClockIn
          multiple
          placeholder="Cost Codes"
          value={selectedCostcodes}
        />
      </Form.Item>
      <Form.Item
        name="timeTypes"
        label="Time Type"
      >
        <Select
          onChange={onFilterChange('timeTypes')}
          allowClear
          options={TIME_TYPES}
          mode="multiple"
          treeNodeFilterProp="title"
          placeholder="Time Type"
          values={selectedTimeTypes}
        />
      </Form.Item>
    </>
  );
}

CustomExportTimeTrackingFilters.propTypes = {
  onFilterChange: PropTypes.string.isRequired,
  selectedProjects: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedCostcodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedTimeTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CustomExportTimeTrackingFilters;
